import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpService } from 'src/app/_provider/http.service';
import { HttpFunctionResult } from '../../HttpFunctionResult';
import { FeedbackService, MsgType } from 'src/app/_provider/feedback.service';

export interface Criticism{
  rate: number,
  text: string,
  anonymousChecked: boolean,
  emailAddress: string
}

@Component({
  selector: 'app-criticism',
  templateUrl: './criticism.page.html',
  styleUrls: ['./criticism.page.scss'],
})
export class CriticismPage implements OnInit {

  public criticism: Criticism = {
    rate: 0,
    text: "",
    anonymousChecked: true,
    emailAddress: ""
  }

  constructor(
    private modalCtrl: ModalController,
    private http: HttpService,
    private feedback: FeedbackService
  ) { }

  ngOnInit() {
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }

  public async sendMail(){

    if(!this.criticism.text)
      return await this.feedback.showError("Bitte geben Sie einen Text an.")
    if(this.criticism.rate == 0)
      return await this.feedback.showError("Bitte geben Sie eine Bewertung an.")
    if(!this.criticism.anonymousChecked && !this.criticism.emailAddress)
      return await this.feedback.showError("Bitte geben Sie eine E-Mail Adresse an oder senden Sie das Feedback anonym.")

    //checken ob es eine gültige E-Mail Adresse ist
    if(!this.criticism.anonymousChecked && !this.criticism.emailAddress.match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/))
      return await this.feedback.showError("Bitte geben Sie eine gültige E-Mail Adresse an.")

    await this.feedback.updateLoading("Feedback senden...")
    const result: HttpFunctionResult<any> = await this.http.sendFeedbackMail(this.criticism)
    await this.feedback.hideLoading()
    if(!result.success)return
    await this.feedback.showMsg(MsgType.Info, "Vielen Dank! Ihr Feedback wurde erfolgreich an uns weitergeleitet.")
    await this.modalCtrl.dismiss()
  }

}
